module.exports = __webpack_public_path__ + "img/user Icon.1ca02028.svg";